import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(sessionStorage.getItem('user') || 'null');

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Check if the route requires admin access
  if (window.location.pathname.startsWith('/admin') && !user.isAdmin) {
    return <Navigate to="/form" replace />;
  }

  return children;
};

export default PrivateRoute; 